/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebillingvatid3Inputs */

const en_profilebillingvatid3 = /** @type {(inputs: Profilebillingvatid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VAT number`)
};

const de_profilebillingvatid3 = /** @type {(inputs: Profilebillingvatid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UID-Nummer`)
};

/**
* | output |
* | --- |
* | "VAT number" |
*
* @param {Profilebillingvatid3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillingvatid3 = /** @type {((inputs?: Profilebillingvatid3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillingvatid3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillingvatid3(inputs)
	return de_profilebillingvatid3(inputs)
});
export { profilebillingvatid3 as "profileBillingVatId" }